// import BasePage from "../../base/BasePage";
// import NavBar from "../../components/navbar";
// import React from "react";
// import withRouter from "../../withRouter";

// class SellerApprovalPage extends BasePage {
//   componentDidMount() {
//     const document = this.getGlobalState("sellerDocument");
//     if (document.status === "Approved") {
//       this.showSuccess("Your request has been approved").then(() =>
//         this.navigateTo("/"),
//       );
//     }
//     if (document.status === "Rejected") {
//       this.showError(
//         "Your request has been rejected contact us at contact@ebowr.com",
//       );
//     }
//   }

//   onClickEdit() {
//     this.navigateTo("/seller/form");
//   }

//   render() {
//     const document = this.getGlobalState("sellerDocument");
//     const isApproved = document === undefined || document.status !== "Approved";
//     return (
//       <>
//         <NavBar isApproved={isApproved} />
//         <div className="overflow-auto">
//           <div className="h-100">
//             <div className="p-3 p-lg-4 text-center">
//               <h1 className="fw-bold mt-3 text-capitalize">
//                 Your Request is Pending
//               </h1>
//               <button
//                 onClick={this.onClickEdit.bind(this)}
//                 type="button"
//                 className="btn btn-primary fs-sm"
//               >
//                 EDIT DOCUMENT
//               </button>
//             </div>
//           </div>
//         </div>
//       </>
//     );
//   }
// }

// export default withRouter(SellerApprovalPage);

import BasePage from "../../base/BasePage";
import NavBar from "../../components/navbar";
import React from "react";
import withRouter from "../../withRouter";
import FindObjectUseCase from "../../usecases/object/FindObjectUseCase";
import { use } from "react";

class SellerApprovalPage extends BasePage {
  interval = null;
  findObjectUseCase = new FindObjectUseCase();

  componentDidMount() {
    this.checkStatus();

    this.interval = setInterval(() => {
      this.checkStatus();
    }, 3000);
  }

  componentWillUnmount() {
    if (this.interval) clearInterval(this.interval);
    this.findObjectUseCase.abort();
  }

  async checkStatus() {
    const user = this.getCurrentUser();
    try {
      const res = await this.findObjectUseCase.execute("sellerDocuments", {
        where: {
          createdBy: { id: user?.id },
        },
        limit: 1,
      });

      console.log("res", res);

      const document = res?.[0];
      if (!document) return;

      //   this.setGlobalState("sellerDocument", document);

      if (document.status === "Approved") {
        console.log("true");
        clearInterval(this.interval);

        this.showSuccess("Your request has been approved").then(() => {
          window.location.href = "/";
        });
      }

      if (document.status === "Rejected") {
        clearInterval(this.interval);
        this.showError(
          "Your request has been rejected contact us at contact@ebowr.com",
        );
      }
    } catch (err) {
      console.error(err);
    }
  }

  onClickEdit() {
    this.navigateTo("/seller/form");
  }

  render() {
    const document = this.getGlobalState("sellerDocument");

    console.log("ddd", document);
    const isApproved = document === undefined || document.status !== "Approved";

    return (
      <>
        <NavBar isApproved={isApproved} />
        <div className="overflow-auto">
          <div className="h-100">
            <div className="p-3 p-lg-4 text-center">
              <h1 className="fw-bold mt-3 text-capitalize">
                Your Request is Pending
              </h1>
              <button
                onClick={this.onClickEdit.bind(this)}
                type="button"
                className="btn btn-primary fs-sm"
              >
                EDIT DOCUMENT
              </button>
            </div>
          </div>
        </div>
      </>
    );
  }
}

export default withRouter(SellerApprovalPage);
